export default function (dataSet, fieldKey) {
  const labels = [];
  const data = [];
  (dataSet?.[fieldKey] || []).map((x) => {
    labels.push(x.market);
    data.push(x.orderamount);
  });
  return {
    hoverBackgroundColor: "red",
    hoverOffset: 4,
    borderWidth: 4,
    labels: labels,
    datasets: [
      {
        backgroundColor: [
          "#002872",
          "var(--primary)",
          "#7659FF",
          "#8976E0",
          "#5E3FBE",
          "#E374F2",
          "#EC4E0F",
          "var(--primary)",
          "#5E3FBE",
          "#0000FF",
          "#00BFFF",
          "#ADD8E6",
        ],
        data: data,
      },
    ],
  };
}
